import React, { useRef, useState, useCallback, useEffect } from 'react';
import {
  setCampaignId,
  setcampaignEditMode,
  setIsLoading,
  setIsLoadingClone,
  setCampaignViewMode,
  resetCampaignData,
} from 'ReduxStore/Slices/campaignSlice';
import {
  getCampaignInfo,
  postCampaignData,
  getCampaigns,
  getCampaignCount,
  putCampaignData
} from 'api/CampaignApi';
import {
  setCampaignTab,
  setCampaignStatus,
  setCampaignTabInfo,
  resetCampaignStatus,
} from 'ReduxStore/Slices/allCampaignSlice';
import { useSelector, useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import ContantLoaderPage from 'views/ContentLoaderPage';
import CampaignTable from './AllCampaignSection/CampaignTable';
import 'bootstrap/dist/css/bootstrap.css';
import '../styles.css';
import { toast } from "react-toastify";
import { setPublishedUrl } from 'ReduxStore/Slices/campaignSlice';
function AllCampaign(props) {
  // Constants
  const EMAIL_CAMPAIGN_TAB = {
    name: 'Email',
    id: 'EMAIL_CAMPAIGN_TAB',
    status: 'active',
    icon: 'fas fa-envelope',
    tab: 'emailCampaign',
  };
  const WEBPAGE_CAMPAIGN_TAB = {
    name: 'Webpage',
    id: 'WEBPAGE_CAMPAIGN_TAB',
    status: '',
    icon: 'fas fa-globe',
    tab: 'webpageCampaign',
  };
  const COMPLAICE_CAMPAIGN_TAB = {
    name: 'Compliance Pending',
    id: 'COMPLIANCE_CAMPAIGN_TAB',
    status: '',
    icon: 'far fa-clock-o',
    tab: 'compliancePending',
  };
  const emailCampaignStatus = [
    { value: 'email_abtest', label: '#AB Test' },
    { value: 'email_draft', label: '#Draft' },
    { value: 'email_completed', label: '#Completed' },
    { value: 'email_active', label: '#Scheduled' },
    { value: 'email_cancelled', label: '#Cancelled' },
    { value: 'archived', label: '#Archived'}
  ];
  const webPageCampaignStatus = [
    { value: 'webpage_draft', label: '#Draft' },
    { value: 'webpage_completed', label: '#Published' },
    { value: 'web_archived', label: '#Archived'}

  ];

  //States
  const [campaingnList, setCampaingnList] = useState([]);
  const [selectedCampaingStatus, setSelectedCampaignStatus] = useState('');
  const [searchText, setSearchText] = useState('');
  const [pageCount, setPageCount] = useState(0);
  const [pageIndex, setPageIndex] = useState(0);
  const { role, companyLevelComplaiceFlag } = useSelector(
    (state) => state.userSetter
  );
  const { isLoading, isLoadingClone } = useSelector(
    (state) => state.campaignSetter
  );
  const { campaignTab, campaignStatus, campaignTabInfo } = useSelector(
    (state) => state.allCampaignSetter
  );
  const [currentTab, setCurrentTab] = useState(role =='publisher'?WEBPAGE_CAMPAIGN_TAB:EMAIL_CAMPAIGN_TAB);

  const searchTextBoxRef = useRef(null);
  const dispatch = useDispatch();
  const history = useHistory();
  const TABS = role =='publisher'?[WEBPAGE_CAMPAIGN_TAB]:[EMAIL_CAMPAIGN_TAB, WEBPAGE_CAMPAIGN_TAB];

  const COMPLIANCE_TABS = [...TABS, COMPLAICE_CAMPAIGN_TAB];

  useEffect(()=>{
    if(role=='publisher'){

    let tab = WEBPAGE_CAMPAIGN_TAB

    tab.status = 'active';
    setTimeout(()=>{
      setCurrentTab(tab);
    
      setSelectedCampaignStatus('');
      setSearchText('');
      dispatch(setCampaignTabInfo(tab));
      dispatch(resetCampaignStatus());
      dispatch(setCampaignTab(tab.id));
    },2000)




    }
  },[])


  //Campaing Funtions
  function viewReport(data) {
    var id = data.id;
    dispatch(setCampaignId(id));
    sessionStorage.setItem('KW_Campaign_Report_Id', id);
    sessionStorage.setItem('KW_Campaign_Report_name', data.name);
    history.push(`/admin/campaign/${id}`);
  }
  function cloneCamp(d) {
    dispatch(setIsLoadingClone(true));
    getCampaignInfo(d.id)
      .then((camp_data) => {
        var d = camp_data;
        var data;
        if (
          d.templateId == null ||
          d.templateId == 'null' ||
          d.templateId == undefined
        ) {
          data = {
            name: d.name + ' (copy)',
            description: d.description,
            subject: d.subject,
            audienceId: d.audienceId,
            type: d.type,
            fromEmail: d.fromEmail,
            isDraft: true,
          };
        } else {
          data = {
            name: d.name + '(copy)',
            description: d.description,
            subject: d.subject,
            templateId: d.templateId,
            audienceId: d.audienceId,
            fromEmail: d.fromEmail,

            type: d.type,
            isDraft: true,
            'grapesjs-react-editorhtml': d['grapesjs-react-editorhtml'],
            'grapesjs-react-editorcss': d['grapesjs-react-editorcss'],
            'grapesjs-react-editorstyles': d['grapesjs-react-editorstyles'],
          };
        }
        postCampaignData(data)
          .then((res_data) => {
            editCampaign(res_data.id);
            dispatch(setIsLoadingClone(false));
          })
          .catch(function (error) {

          });
      })
      .catch(function (error) {

      });
  }
  function editCampaign(id) {
    dispatch(setCampaignId(id));
    dispatch(setcampaignEditMode(true));
    sessionStorage.setItem('KW_Campaign_Edit_Id', id);
    sessionStorage.setItem('On_Edit', true);
    sessionStorage.setItem('del_cache', false);
    history.push(`/admin/campaign/create`);
  }

  function archive(data){
    let id = data.id
    console.log(id)
    putCampaignData( { status: data.status =='Deleted'? 'Active': 'Deleted'} ,id)
      .then((response) => {

        let temp = [...campaingnList]
        temp = temp.filter(t => t.id != id)
        setCampaingnList(temp)


        if(data.status =='Deleted')
          toast.success("Your campaign has been Unarchived successfully");
else
toast.success("Your campaign has been archived successfully");

        })
      .catch((error) => {
        toast.error("Something went wrong. Please try again.");
      });
  }
  function viewCampaign(id) {
    dispatch(setCampaignId(id));
    dispatch(setCampaignViewMode(true));
    dispatch(setPublishedUrl(campaingnList.find((x) => x.id === id).publishUrl));
    history.push(`/admin/campaign/create`);
  }
  function toAudience(id) {
    sessionStorage.setItem('audience_list_id', id);
    history.push(`/admin/contact/audience/list/${id}`);
  }

  //Tab Component
  const NavTab = (tab) => {
    let currentStatus = '';
    if (currentTab.id === tab.tabinfo.id) {
      currentStatus = 'active';
    } else {
      currentStatus = '';
    }
    return (
      <li className='nav-item'>
        <a
          onClick={() => {
            tab.tabChanged(tab.tabinfo);
          }}
          className={`nav-link ${currentStatus}`}
          href={'#' + tab.tabinfo.id}
          role='tab'
          data-toggle='tab'
          key={tab.key_id}
        >
          <i className={tab.tabinfo.icon}></i> {tab.tabinfo.name}
        </a>
      </li>
    );
  };

  // Campaign Status Component
  const RadioInput = ({ name, label, value, isChecked, handleChange }) => {
    const handleRadioChange = (e) => {
      const { id } = e.currentTarget;
      handleChange(id);
    };

    return (
      <>
        <input
          type='radio'
          className='custom-radio'
          name={name}
          id={value} // htlmlFor targets this id.
          checked={isChecked}
          onChange={handleRadioChange}
        />
        <label htmlFor={value}>
          <span>{label}</span>
        </label>
      </>
    );
  };

  function getCampaignType(param) {
    switch (param) {
      case 'EMAIL_CAMPAIGN_TAB':
        return 'email';
      case 'WEBPAGE_CAMPAIGN_TAB':
        return 'publishedContent';
      case 'COMPLIANCE_CAMPAIGN_TAB':
        return 'compliance';
    }
  }
  function getCampaignStatus(param) {
    let status = '';
    switch (param) {
      case 'webpage_draft': {
        status = 'Draft';
        break;
      }
      case 'webpage_completed': {
        status = 'Published';
        break;
      }
      case 'email_abtest': {
        status = 'ABTest';
        break;
      }
      case 'email_draft': {
        status = 'Draft';
        break;
      }
      case 'email_completed': {
        status = 'Completed';
        break;
      }
      case 'email_active': {
        status = 'Active';
        break;
      }
      case 'email_cancelled': {
        status = 'Paused';
        break;
      }
      case 'archived': {
        status = 'Deleted';
        break;
      }
      case 'web_archived': {
        status = 'Deleted';
        break;
      }
    }
    return status;
  }

  const queryString = ({
    currentTab,
    campaignStatusValue,
    pageSize,
    pageIndex,
    searchText,
  }) => {
    let type = getCampaignType(currentTab);
    let status = getCampaignStatus(campaignStatusValue);
    let st = searchText;

    let extraQuery = {};
    if (status === 'Draft') {
      extraQuery = { isDraft: true };
    }
    if (status === 'Published') {
      extraQuery = { isDraft: false };
    }
    if (status === 'ABTest') {
      extraQuery = { ...extraQuery, isABTest: true };
    }
    if (status === 'Completed' || status === 'Paused' || status === 'Active' || status === 'Deleted') {
      extraQuery = { ...extraQuery, status: status };
    }
    if (st) {
      extraQuery = { ...extraQuery, search: st };
    }
    if (type === 'compliance') {
      return { complianceStatus: 'Pending'};
    } else {
      return { ...extraQuery, type: type };
    }

  };

  const fetchData = useCallback(
    async ({
      pageSize,
      pageIndex,
      currentTab = role=='publisher'?'WEBPAGE_CAMPAIGN_TAB':'EMAIL_CAMPAIGN_TAB',
      campaignStatusValue,
      searchText,
    }) => {

      dispatch(setIsLoading(true));
      const startRow = pageSize * pageIndex;

      let qs = queryString({
        currentTab,
        campaignStatusValue,
        pageSize,
        pageIndex,
        searchText,
      });


      setPageIndex(pageIndex);
      getCampaignCount(qs)
        .then((data) => {

          setPageCount(Math.ceil(data.count / pageSize));
        })
        .catch((e) => { });
      console.log("klmsef",qs)

      qs = { ...qs, limit: pageSize, offset: pageSize * ((pageIndex + 1) - 1) };

      await getCampaigns(qs)
        .then((data) => {
          setCampaingnList(data);
          dispatch(setIsLoading(false));
        })
        .catch((e) => { });
      dispatch(resetCampaignData());
    },
    []
  );

  const tabChanged = (tab) => {
    tab.status = 'active';
    setCurrentTab(tab);
    setSelectedCampaignStatus('');
    setSearchText('');
    dispatch(setCampaignTabInfo(tab));
    dispatch(resetCampaignStatus());
    dispatch(setCampaignTab(tab.id));
  };

  const handleCampaignStatusChange = (inputValue) => {
    setSelectedCampaignStatus(inputValue);
    dispatch(setCampaignStatus(inputValue));
  };

  useEffect(() => {
    if (campaignTabInfo) {
      setCurrentTab(campaignTabInfo)
    }
    setSelectedCampaignStatus(campaignStatus)
  }, [])
  return (
    <>
      {isLoadingClone ? (
        <ContantLoaderPage />
      ) : (
        <div className='templates'>
          <div className='page_heading'>
            <h2>Campaign List</h2>
          </div>
          <div className='cmpgn_list_outer'>
            <div className='cmpgn_tab_erap'>
              <ul className='nav nav-tabs' role='tablist'>
                {companyLevelComplaiceFlag
                  ? COMPLIANCE_TABS.map((tab, index) => {
                    return (
                      <NavTab
                        key={index}
                        key_id={tab.id}
                        tabChanged={tabChanged}
                        tabinfo={tab}
                      />
                    );
                  })
                  : TABS.map((tab, index) => {
                    return (
                      <NavTab
                        key={index}
                        key_id={tab.id}
                        tabChanged={tabChanged}
                        tabinfo={tab}
                      />
                    );
                  })}
              </ul>
              <div className='cmpgn-head-bar m-3'>
                <div className='search_bar_wrap'>
                  <input
                    className='form-control search-input'
                    id='search_input_by_tag_completed'
                    placeholder='Enter Name or Description '
                    ref={searchTextBoxRef}
                    onKeyDown={(e) => {
                      if (e.keyCode === 13) {
                        setSearchText(e.target.value);
                      }
                    }}
                  />
                  <button
                    onClick={() =>
                      setSearchText(searchTextBoxRef.current.value)
                    }
                    className='lg_btn tertiary search_btn'
                  >
                    {false ? 'Loading...' : 'Search'}
                  </button>
                  <div className='select-pill-button ml-2 '>
                    {campaignTab === 'EMAIL_CAMPAIGN_TAB' &&
                      emailCampaignStatus.map((status, index) => {
                        return (
                          <RadioInput
                            name='option'
                            value={status.value}
                            label={status.label}
                            isChecked={selectedCampaingStatus === status.value}
                            handleChange={handleCampaignStatusChange}
                            key={index}
                          />
                        );
                      })}
                    {campaignTab === 'WEBPAGE_CAMPAIGN_TAB' &&
                      webPageCampaignStatus.map((status, index) => {
                        return (
                          <RadioInput
                            name='option'
                            value={status.value}
                            label={status.label}
                            isChecked={selectedCampaingStatus === status.value}
                            handleChange={handleCampaignStatusChange}
                            key={index}
                          />
                        );
                      })}
                  </div>
                </div>
              </div>

              <div className='d-flex mr-4'>
                <span className='inline-label ml-auto'>
                  Page No. {pageIndex + 1} of {pageCount}
                </span>
              </div>
              <div className='tab-content'>
                <CampaignTable
                  columns={[]}
                  data={campaingnList}
                  pageCount={pageCount}
                  fetchData={fetchData}
                  loading={isLoading}
                  currentTab={campaignTab}
                  tab={currentTab.tab}
                  campaignStatusValue={campaignStatus}
                  searchText={searchText}
                  viewReport={viewReport}
                  cloneCamp={cloneCamp}
                  editCampaign={editCampaign}
                  viewCampaign={viewCampaign}
                  toAudience={toAudience}
                  role={role}
                    archive={archive}
                  companyLevelComplaiceFlag={companyLevelComplaiceFlag}
                ></CampaignTable>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default AllCampaign;
